import type React from 'react';

import type { IconProps } from 'types/icon';

const ChevronRight: React.FC<IconProps> = ({
  size = '20',
  color = 'currentColor',
  ...attributes
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      focusable="false"
      aria-hidden="true"
      {...attributes}
    >
      <path
        d="M7.3934 3.34261C7.73027 3.00573 8.27625 3.00573 8.61313 3.34261L17.64732 12.376L8.61393 21.41814C8.2772 21.7551 7.72943 21.75564 7.3934 21.41895C7.05652 21.08226 7.05622 20.53619 7.3926 20.19923L15.20706 12.37679L7.3934 4.56236C7.0565 4.22547 7.0565 3.6795 7.3934 3.34261Z"
        fill={color}
      />
    </svg>
  );
};

export default ChevronRight;
